import React from 'react'

const Arrow = props => (
  <svg width='24' height='24' viewBox='0 0 24 24' {...props}>
    <path id='a' d='M15.498 15L17 13.614 12 9l-5 4.614L8.502 15 12 11.772z' />
  </svg>
)

export default Arrow



// WEBPACK FOOTER //
// ./src/svg-icons/Arrow.js